"use strict";
// NOTICE: can't use src/cookies here
// would create a circular dependency as that library requires ENV to be loaded
Object.defineProperty(exports, "__esModule", { value: true });
var Telemetry_1 = require("src/Telemetry");
var canary_env_1 = require("./canary.env");
var cordova_env_1 = require("./cordova.env");
var dev_env_1 = require("./dev.env");
var prod_env_1 = require("./prod.env");
var stag_env_1 = require("./stag.env");
var test_env_1 = require("./test.env");
var types_1 = require("./types");
var usni_env_1 = require("./usni.env");
var usni_dev_env_1 = require("./usni_dev.env");
var loadEnv = function (desiredEnv) {
    // load config
    var defaultEnv = process.env.DEFAULT_ENV;
    var fallbackEnv = types_1.ENV_OPTIONS.includes(desiredEnv) ? desiredEnv : defaultEnv;
    var usedEnv = (types_1.ENV_OPTIONS.includes(fallbackEnv) ? fallbackEnv : 'prod');
    usedEnv = defaultEnv === 'usni' ? 'usni' : usedEnv;
    console.info('[LOAD_ENVIRONMENT] Requested environment: ' + desiredEnv);
    console.info('[LOAD_ENVIRONMENT] Default Environment environment: ' + defaultEnv);
    console.info('[LOAD_ENVIRONMENT] Loading environment: ' + usedEnv);
    switch (usedEnv) {
        case 'test':
            return test_env_1.default();
        case 'dev':
            return dev_env_1.default();
        case 'stag':
            return stag_env_1.default();
        case 'canary':
            return canary_env_1.default();
        case 'prod':
            return prod_env_1.default();
        case 'usni_dev':
            return usni_dev_env_1.default();
        case 'usni':
            return usni_env_1.default();
        case 'cordova':
            return cordova_env_1.default();
    }
    // env options should be exhausted by above switch
    /* istanbul ignore next */
    (function (_) {
        var error = new Error("[LOAD_ENVIRONMENT] Should not reach here: " + usedEnv);
        Telemetry_1.Sentry.logError(error);
        throw error;
    })(usedEnv);
};
exports.default = loadEnv;
